import {Injectable} from '@angular/core';
import {QueryEntity} from '@datorama/akita';
import {NewsletterState, Store} from './store';

@Injectable({ providedIn: 'root' })
export class NewsletterQuery extends QueryEntity<NewsletterState> {

  constructor(protected store: Store) {
    super(store);
  }

}
